export function calcRFromPnl(pnl, risk) {
  const p = parseFloat(pnl);
  const r = parseFloat(risk);
  if (Number.isNaN(p) || Number.isNaN(r) || r === 0) return null;
  return p / Math.abs(r);
}

export function fmtR(v, dp = 1) {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return '—';
  const n = Number(v);
  return `${n > 0 ? '+' : ''}${n.toFixed(dp)}R`;
}

export function fmtMoney(v, signed = false) {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return '—';
  const n = Number(v);
  const sign = n < 0 ? '-' : signed && n > 0 ? '+' : '';
  const abs = Math.abs(n);
  return `${sign}$${abs.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function rColor(v) {
  if (v === null || v === undefined) return 'text-zinc-400';
  if (v > 0) return 'text-emerald';
  if (v < 0) return 'text-red-400';
  return 'text-zinc-300';
}

export function fmtTradeDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export const PERIODS = [
  { key: 'this_month', label: 'This Month' },
  { key: 'last_month', label: 'Last Month' },
  { key: 'all_time', label: 'All Time' },
];
